import { Component, OnInit } from '@angular/core';
import { BaseTableComponent } from '../../../shared/tables/base-table/base-table';
import { BehaviorCodeInterventionsTableColumns } from '../behavior-code-interventions-models/behavior-code-interventions-table-columns.enum';
import { BehaviorCodeInterventionUpdateDto } from '@whetstoneeducation/hero-common';
import { AppConfirmationDialogService } from 'src/app/shared/confirmation-dialog/confirmation-dialog.service';
import { AppToastManagerService } from 'src/app/shared/services/toast-manager.service';
import { AppBehaviorCodeInterventionsService } from '../behavior-code-interventions.service';
import { DEFAULT_DIALOG_RESULT } from '../../../shared/confirmation-dialog/confirmation-dialog-options.interface';

@Component({
  selector: 'app-behavior-code-interventions-table',
  templateUrl: './behavior-code-interventions-table.template.html',
  styleUrls: ['./behavior-code-interventions-table.scss']
})
export class AppBehaviorCodeInterventionsTableComponent
  extends BaseTableComponent<any>
  implements OnInit
{
  public get displayedColumns() {
    return Object.values(BehaviorCodeInterventionsTableColumns);
  }

  public columnValues = {
    [BehaviorCodeInterventionsTableColumns.NAME]: ['intervention', 'name'],
    [BehaviorCodeInterventionsTableColumns.DESCRIPTION]: ['description'],
    [BehaviorCodeInterventionsTableColumns.TRIGGER_AT]: ['triggerCount']
  };

  public showPagination: boolean;

  public columns = BehaviorCodeInterventionsTableColumns;
  constructor(
    public confirmationDialog: AppConfirmationDialogService,
    private toastManager: AppToastManagerService,
    public behaviorCodeInterventionService: AppBehaviorCodeInterventionsService
  ) {
    super();
  }

  public ngOnInit() {
    this.showPagination = this.dataArr?.length < this.tableFilters?.count;
  }

  public async deleteInterventionFromBehavior(
      row: BehaviorCodeInterventionUpdateDto
    ): Promise<void> {
      const interventionId = row.id;
      const ref = this.confirmationDialog.openDialog({
        title: `Remove Intervention`,
        content: 'Are you sure you want to remove the intervention?'
      });
      ref.afterClosed().subscribe(async (result: string) => {
        if (result === DEFAULT_DIALOG_RESULT.YES) {
          await this.behaviorCodeInterventionService.removeBehaviorIntervention(
            interventionId
          );
          this.toastManager.success('Intervention removed successfully!');
          this.dataArr = this.dataArr.filter(
            (intervention) => intervention.id !== interventionId
          );
        }
      });
    }
}
